import React from 'react';
import { ReportCard } from '../reportsTypes';
import styles from './ReportCard.module.css';

interface ReportCardProps {
  report: ReportCard;
  onGenerate?: (id: string) => void;
}

const iconPaths: Record<string, string> = {
  lowStock:
    'M20 2H4c-1 0-2 1-2 2v3.01c0 .72.43 1.34 1 1.69V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.7c.57-.35 1-.97 1-1.69V4c0-1-1-2-2-2zm-5 12H9v-2h6v2zm5-7H4V4h16v3zM12 17h1v-2h-1v-1h-1v1h-1v2h1v1h1v-1z',
  damage:
    'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z',
  shrink:
    'M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z',
  movement:
    'M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z',
  picking:
    'M20 2H4c-1 0-2 1-2 2v3.01c0 .72.43 1.34 1 1.69V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.7c.57-.35 1-.97 1-1.69V4c0-1-1-2-2-2zm-5 12H9v-2h6v2zm5-7H4V4h16v3z',
};

export const ReportCardComponent: React.FC<ReportCardProps> = ({ report, onGenerate }) => {
  const handleGenerate = () => {
    onGenerate?.(report.id);
  };

  return (
    <div className={styles.card}>
      <div
        className={styles.iconWrapper}
        style={{ backgroundColor: report.iconBg }}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill={report.iconColor}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d={iconPaths[report.icon] || ''} />
        </svg>
      </div>
      <h3 className={styles.title}>{report.title}</h3>
      <p className={styles.description}>{report.description}</p>
      <button className={styles.button} onClick={handleGenerate}>
        Generate Report
      </button>
    </div>
  );
};
